export default defineNuxtPlugin((nuxtApp) => {
  const p: any = nuxtApp.payload
  if (!p.data) p.data = {}
  if (!p._errors) p._errors = {}
  const orig = (nuxtApp as any)._asyncData
})
